import { create } from "zustand";
import { startOfWeek } from "date-fns";
import { dateToLocalTime } from "@/utils/format-date-with-locale";

// Type definitions
type CalendarView = "day" | "week" | "month" | "agenda";

interface CalendarState {
  view: CalendarView;
  currentDate: Date;
  startOfTheWeek: Date;
  isMobile: boolean;
  setView: (view: CalendarView) => void;
  setCurrentDate: (date: Date) => void;
  setStartOfTheWeek: (date: Date) => void;
  setIsMobile: (isMobile: boolean) => void;
}

// Helper function to initialize the start of the week
const initializeStartOfWeek = (timezone?: string) => {
  // Get today's date in local timezone
  const today = new Date();
  // Convert to the organization's timezone if provided
  const localDate = timezone ? dateToLocalTime(today, timezone) : today;
  // Get the start of the week (Monday)
  return startOfWeek(localDate, { weekStartsOn: 1 });
};

// Create the store with initial values
const useCalendarStore = create<CalendarState>((set) => ({
  // Initialize with defaults
  view: "agenda", //
  // typeof window !== "undefined" && window.innerWidth < 768 ? "day" : "week",
  currentDate: new Date(),
  startOfTheWeek: initializeStartOfWeek(),
  isMobile: typeof window !== "undefined" && window.innerWidth < 768,

  // Actions
  setView: (view) => set({ view }),

  setCurrentDate: (date) => set({ currentDate: date }),

  setStartOfTheWeek: (date) => set({ startOfTheWeek: date }),

  setIsMobile: (isMobile) => set({ isMobile }),
}));

export default useCalendarStore;
